<div class="content-body">
  <app-loading-spinner [isLoading]="isLoading"></app-loading-spinner>
  <div class="container-fluid">
    <!-- <div class="row page-titles mx-0">
      <app-breadcrumb [breadcrumb]="breadcrumbList"> </app-breadcrumb>
    </div> -->
    <div class="card-header border-0 cm-content-box box-primary" *ngIf="table as t">
      <div class="separator"></div>
      <div class="d-flex align-items-start justify-content-between w-100">
        <div class="flex-grow-1 me-3">
          <h4 class="text-black fs-20">{{ t?.name }}</h4>
          <div class="d-flex align-items-center gap-2 mb-1">
            <span [ngClass]="getOrderStatusBadgeClass(orderStatusSlug)">{{ statusOrder }}</span>
          </div>
          <p class="fs-13 mb-0" *ngIf="order?.id as oid">Orden #{{ oid }}</p>
          <p class="fs-13 mb-0">
            {{ order?.createdAt ? (order?.createdAt | date:'dd/MM/yy HH:mm':'America/Santiago') : (order?.date || '') }}
          </p>
          <p class="fs-13 mb-0">Cliente: {{ customerName || 'Sin nombre' }}</p>
        </div>
        <div class="ms-auto">
          <button type="button" class="btn btn-sm btn-outline-secondary d-flex align-items-center" (click)="onEditClientName()" [disabled]="isLoading" aria-label="Editar nombre del cliente">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <!-- Catálogo embebido para agregar items directamente a la orden (colapsable) -->
    <div class="card mt-2" *ngIf="!isOrderClosed">
      <div class="card-body">
        <div class="d-flex align-items-center justify-content-between mb-3" role="button" (click)="toggleCatalog()" aria-label="Alternar catálogo">
          <h5 class="mb-0">Catálogo</h5>
          <mat-icon aria-hidden="true" class="ms-3">{{ isCatalogOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
        </div>
        <div class="catalog-plain" *ngIf="isCatalogOpen && catalogGroups && catalogGroups.length > 0">
          <div class="catalog-block mb-2" *ngFor="let g of catalogGroups; let i = index">
            <div #catHeader class="catalog-header d-flex align-items-center border rounded px-3 py-2 bg-light"
                 role="button" (click)="toggleCategory(i)">
              <span class="me-2 fw-semibold">{{ g?.categoryName }}</span>
              <mat-icon aria-hidden="true" class="ms-auto">{{ isCategoryOpen(i) ? 'expand_less' : 'expand_more' }}</mat-icon>
            </div>
            <div class="catalog-body px-1 py-2" *ngIf="isCategoryOpen(i)">
              <div class="text-muted small mb-2" *ngIf="g && (g.items?.length || 0) === 0">No hay productos en esta categoría.</div>
              <div class="catalog-items">
                <ng-container *ngFor="let p of (g?.items || []); let j = index">
                  <div class="catalog-item" *ngIf="shouldShowProduct(p)">
                    <div class="d-flex align-items-center justify-content-between border rounded p-2 bg-white">
                      <div class="me-2 min-w-0">
                        <div class="fw-semibold clamp-2">{{ p?.name || ('Producto '+(j+1)) }}</div>
                        <div class="text-muted small" *ngIf="getTotalItemsForMenuProduct(getMpKey(p)) > 0">
                          {{ getTotalItemsForMenuProduct(getMpKey(p)) }}
                        </div>
                        <div class="text-muted small">
                          $ {{ (getTotalItemsForMenuProduct(getMpKey(p)) > 0 ? getTotalSellPriceForMenuProduct(getMpKey(p)) : (p?.sellPrice || 0)) | number:'1.0-0' }}
                        </div>
                      </div>
                      <div class="d-flex align-items-center gap-2">
                        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="removeMenuProduct(getMpKey(p))" [disabled]="isLoading">−</button>
                        <span class="px-1 text-center" style="min-width: 20px;">{{ getQtyForMenuProduct(getMpKey(p)) }}</span>
                        <button type="button" class="btn btn-primary btn-sm" (click)="addMenuProduct(getMpKey(p))" [disabled]="isLoading">+</button>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-lg-12 mb-4">
            <h4 class="d-flex justify-content-between align-items-center mb-3">
              <span class="text-black">
                Su orden: ${{ order?.totalAmount }}
                <span class="ms-2 badge bg-secondary">{{ statusOrder }}</span>
              </span>
              <span class="badge badge-primary badge-pill">{{ orderList.length }}</span>
            </h4>
            <!-- Toolbar de agrupación: botón en una fila separada -->
            <div class="d-flex align-items-start mb-2">
              <button class="btn btn-outline-dark btn-sm" *ngIf="orderList && orderList.length > 0" (click)="toggleGroupingMode()">
                {{ groupingMode ? 'Salir de agrupar' : 'Agrupar' }}
              </button>
            </div>
            <!-- Grid de badges de grupos en su propia fila -->
            <div class="group-badges-grid" [class.grid-4]="!groupingMode && !canEnterGroupingMode()" *ngIf="groupingMode || hasGroupSelection">
              <span class="badge group-badge" *ngFor="let g of groupsSaved; let i = index" [style.backgroundColor]="g.color" style="color: white;" (click)="onEditGroupName(g.gid)" title="Cambiar nombre del grupo">
                <span class="name">{{ getGroupDisplayName(g, i) }}</span>
                <span class="amount">${{ getGroupTotal(g.gid) | number:'1.0-0' }}</span>
                <!-- Check de pago del grupo -->
                <span class="paid-check" *ngIf="isGroupEffectivelyPaid(g.gid)" aria-label="Grupo pagado">✓</span>
                <!-- Acciones en la misma fila (sólo grupos sin pago) -->
                <span class="actions" *ngIf="!isGroupEffectivelyPaid(g.gid)">
                  <button mat-icon-button class="icon-btn" (click)="onEditGroupName(g.gid); $event.stopPropagation()" title="Editar grupo">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button mat-icon-button class="icon-btn" (click)="onDeleteSavedGroup(g.gid, $event)" title="Eliminar grupo">
                    <mat-icon>delete</mat-icon>
                  </button>
                </span>
              </span>
              <!-- Badge para nuevo grupo con color distintivo (solo si ya hay ítems asociados) -->
              <span *ngIf="groupingMode && !groupEditMode && hasNewGroupSelection" class="badge group-badge" [style.backgroundColor]="newGroupBadgeColor" style="color: white;" title="Nuevo grupo">
                <span class="name">Nuevo</span>
              </span>
            </div>
            <!-- Warning y botón para borrar orden cuando ítems cancelados y sin pago, o vacía abierta -->
            <div class="alert alert-warning d-flex align-items-center justify-content-between py-2 px-3 mb-2" *ngIf="canDeleteOrCloseOrder()">
              <span class="me-3">Ítems cancelados y pago no realizado, o la orden está vacía. Puedes borrar esta orden.</span>
              <button type="button" class="btn btn-danger btn-sm" (click)="onDeleteOrderWithWarning()" [disabled]="isLoading">
                Borrar orden
              </button>
            </div>
            <ul class="list-group mb-3">
              @for(item of orderList; track item.uuid){
                <div class="group-item-wrapper position-relative" [class.grouping-active]="groupingMode" [class.group-selected-prev]="(!groupingMode && isItemInAnySavedGroup(item.uuid)) || (groupEditMode && isItemSelected(item.uuid))" [class.group-selected-new]="groupingMode && !groupEditMode && isItemNewSelected(item.uuid)" [class.group-disabled]="groupingMode && !canGroupItem(item.uuid)" [class.grouping-new]="groupingMode && !groupEditMode">
                  <!-- Fondo dinámico igual al color del badge -->
                  <div class="group-colored-bg" *ngIf="getItemBackgroundColor(item.uuid)" [style.backgroundColor]="getItemBackgroundColor(item.uuid)"></div>
                  <app-item-order
                    [item]="item"
                    [canEdit]="!!item.canEdit"
                    [canCancel]="!!item.canCancel"
                    (addItem)="onAddItem(item.uuid)"
                    (removeItem)="onRemoveItem(item.uuid)"
                    (cancelItem)="onCancelItem(item.uuid)"
                    (changeStatus)="onChangeItemStatus($event)"
                  >
                  </app-item-order>
                  <!-- Eliminado overlay para que el click en el ítem no afecte al grupo; interacción queda sólo en el badge -->
                  <span class="group-select-badge" *ngIf="groupingMode || isItemInPaidGroup(item.uuid) || isItemSelected(item.uuid) || isItemNewSelected(item.uuid)" [style.backgroundColor]="getGroupBadgeColor(item.uuid)" (click)="groupingMode && onClickGroupBadge(item.uuid)" [class.disabled]="!groupingMode || (groupingMode && !canGroupItem(item.uuid))" [attr.title]="groupingMode ? 'Editar grupo / Agregar-Quitar' : 'Grupo'">
                    <ng-container *ngIf="groupingMode; else viewModeIcon">
                      <ng-container *ngIf="isItemInPaidGroup(item.uuid); else groupingEditable">
                        ✓
                      </ng-container>
                      <ng-template #groupingEditable>
                        {{ (isItemNewSelected(item.uuid) || (groupEditMode && isItemSelected(item.uuid))) ? '✓' : (isItemInAnySavedGroup(item.uuid) ? '' : '+') }}
                      </ng-template>
                    </ng-container>
                    <ng-template #viewModeIcon>
                      <ng-container *ngIf="isItemInPaidGroup(item.uuid)">
                        ✓
                      </ng-container>
                    </ng-template>
                  </span>
                </div>
              }
            </ul>

            <!-- Advance all items footer button -->
            <div class="d-flex justify-content-end mb-3" *ngIf="canAdvanceAll()">
              <button class="btn btn-outline-primary" (click)="onAdvanceAllPrimary()">
                Avanzar todos
              </button>
            </div>

            <!-- Descuento (primero) -->
            <div class="list-group mt-3">
              <div class="list-group-item d-flex align-items-center justify-content-between">
                <div class="me-3 w-100">
                  <label class="form-label mb-1">Descuento</label>
                  <div class="d-flex gap-2 align-items-center flex-wrap">
                    <input type="number" min="0" step="1" inputmode="numeric" class="form-control" style="max-width: 140px;" [(ngModel)]="discountAmount" (ngModelChange)="onDiscountAmountChange($event)" placeholder="Monto" [disabled]="!canEditDiscount()" />
                    <input type="text" class="form-control" style="max-width: 260px;" [(ngModel)]="discountNote" placeholder="Motivo del descuento" [disabled]="!canEditDiscount()" />
                    <button *ngIf="!isOrderClosed" type="button" class="btn btn-outline-primary" (click)="onApplyDiscount()" [disabled]="isLoading || !orderHashId">
                      Aplicar
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Delivery (solo mesas Delivery) -->
            <div class="list-group mt-3" *ngIf="isDeliveryTable">
              <div class="list-group-item d-flex align-items-center justify-content-between">
                <div class="me-3 w-100">
                  <label class="form-label mb-1">Delivery</label>
                  <div class="d-flex gap-2 align-items-center flex-wrap">
                    <input type="number" min="0" step="1" inputmode="numeric" class="form-control" style="max-width: 140px;" [(ngModel)]="deliveryAmount" (ngModelChange)="onDeliveryAmountChange($event)" placeholder="Monto" [disabled]="!canEditDelivery()" />
                    <input type="text" class="form-control" style="max-width: 260px;" [(ngModel)]="deliveryNote" placeholder="Nota del delivery" [disabled]="!canEditDelivery()" />
                    <button *ngIf="!isOrderClosed" type="button" class="btn btn-outline-primary" (click)="onApplyDelivery()" [disabled]="isLoading || !orderHashId">
                      Aplicar
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Total a imprimir (considera descuento) -->
            <div class="d-flex justify-content-end mt-3">
              <div class="text-end">
                <div class="text-muted">Total a imprimir</div>
                <div class="fs-5 fw-bold">${{ totalAfterDiscount | number:'1.0-0' }}</div>
              </div>
            </div>

            <!-- Propina sugerida y total final -->
            <div class="d-flex justify-content-end mt-2">
              <div class="text-end">
                <div class="text-muted">Propina sugerida (10%)</div>
                <div class="fw-semibold">${{ suggestedTip | number:'1.0-0' }}</div>
              </div>
            </div>
            <div class="d-flex justify-content-end mt-1">
              <div class="text-end">
                <div class="text-muted">Total</div>
                <div class="fs-5 fw-bold">${{ finalTotal | number:'1.0-0' }}</div>
              </div>
            </div>

            <!-- Pago realizado (mostrar después del Total) -->
            <div class="d-flex justify-content-end mt-1" *ngIf="paidTotalDisplay > 0">
              <div class="text-end">
                <!-- Tabla de pagos por grupo -->
                <div class="mt-2" *ngIf="(paidGroupsDetails?.length || 0) > 0">
                  <div class="fw-semibold mb-1">Pagos realizados</div>
                  <table class="table table-sm align-middle">
                    <thead>
                      <tr>
                        <th>Grupo</th>
                        <th>Método</th>
                        <th class="text-end">Total</th>
                        <th class="text-end">Tip</th>
                        <th class="text-end">Pagado</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let pg of paidGroupsDetails">
                        <td class="text-muted py-1">{{ pg.name }}</td>
                        <td class="text-muted py-1">{{ getMethodLabel(pg.method) }}</td>
                        <td class="text-end py-1">${{ pg.amount | number:'1.0-0' }}</td>
                        <td class="text-end py-1" [class.text-muted]="(pg.tip || 0) === 0">${{ (pg.tip || 0) | number:'1.0-0' }}</td>
                        <td class="text-end fw-semibold py-1">${{ pg.total | number:'1.0-0' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- Restante por ingresar (propina opcional) -->
            <div class="d-flex justify-content-end mt-1">
              <div class="text-end">
                <div class="text-muted">Restate por ingresar (sin Propina)</div>
                <div class="fs-6 fw-semibold">${{ remainingDisplay | number:'1.0-0' }}</div>
              </div>
            </div>

            <!-- <form>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Promo code"
                />
                <button class="btn btn-primary">Validar</button>
              </div>
            </form> -->
          </div>
        </div>
      </div>
    </div>
    <!-- Pago parcial por grupo -->
    <div class="mb-3" *ngIf="(partialGroupOptionsCombo.length || 0) > 0">
      <div class="d-flex align-items-center flex-wrap gap-2">
        <span class="fs-13">Pago parcial por grupo</span>
        <div style="min-width: 260px; max-width: 320px; flex: 1 1 320px;">
          <app-combobox
            [options]="partialGroupOptionsCombo"
            [selectedValue]="selectedGroupId"
            placeholder="Seleccione grupo…"
            (selected)="onPartialGroupSelected($event)"
            (cleared)="onPartialGroupCleared()"></app-combobox>
        </div>
        <button class="btn btn-outline-primary btn-sm" (click)="goToPartialPayment()" [disabled]="!selectedGroupId || (partialGroupOptionsCombo.length || 0) === 0 || isGroupPaid(selectedGroupId)">
          Pagar parcial
        </button>
      </div>
    </div>
    <div class="mb-5">
      <ul class="d-flex align-items-center">
        <li>
          <!-- <a routerLink="/admin/cms-email-add" class="btn btn-primary"
          >Go!</a
        > -->
          <button class="btn btn-primary me-2" (click)="goToOrderView()">
            Volver
          </button>
        </li>
        <li>
          <!-- Voucher: visible si canShowVoucher() -->
          <button
            class="btn btn-primary me-2"
            (click)="printVoucher()"
            *ngIf="canShowVoucher()"
          >
            Voucher
          </button>

          <!-- Pago: visible si canShowPay() -->
          <button
            class="btn btn-primary me-2"
            (click)="goToPayment()"
            *ngIf="canShowPay()"
            [disabled]="isPaymentDisabled"
          >
            Pagar
          </button>

          <!-- Show Delete only when order is OPEN and all items are pending -->
          <button
            class="btn btn-danger"
            *ngIf="canDeleteOrder()"
            (click)="onDeleteOrder()"
          >
            Eliminar orden
          </button>
        </li>
      </ul>
    </div>
  </div>
</div>
